import { useEffect, useState } from "react";
import { FormControl, FormHelperText, FormLabel, Input, Stack, useToast } from "@chakra-ui/react";
import { ModalShell } from "../../../shared/ui";
import { useUpdateUserAccessMutation } from "../hooks/useUpdateUserAccessMutation";

// Liberação manual de acesso (TSK-81): o admin recebe o pagamento por fora (ex.: Pix,
// circuit breaker do Ciclo 1) e informa até quando a conta está paga. As datas são o
// ÚLTIMO dia de acesso, inclusivo. Quem assina pelo gateway tem a data gravada pelo
// webhook; editar aqui sobrescreve.
export default function UserAccessModal({ user, onClose }) {
  const toast = useToast();
  const updateAccess = useUpdateUserAccessMutation();
  const [trialAte, setTrialAte] = useState("");
  const [assinaturaAte, setAssinaturaAte] = useState("");

  useEffect(() => {
    setTrialAte(user?.trial_ate ?? "");
    setAssinaturaAte(user?.assinatura_ate ?? "");
  }, [user]);

  const handleSubmit = (event) => {
    event.preventDefault();
    updateAccess.mutate(
      { id: user.id, trialAte, assinaturaAte },
      {
        onSuccess: () => {
          toast({
            title: "Acesso atualizado",
            status: "success",
            duration: 4000,
          });
          onClose();
        },
        onError: (error) =>
          toast({
            title: "Não foi possível atualizar o acesso",
            description:
              error.response?.data?.erros?.[0]?.mensagem ?? error.response?.data?.mensagem,
            status: "error",
            duration: 5000,
            isClosable: true,
          }),
      },
    );
  };

  return (
    <ModalShell
      isOpen={Boolean(user)}
      onClose={onClose}
      title={`Acesso — ${user?.email ?? ""}`}
      onSubmit={handleSubmit}
      isSubmitting={updateAccess.isPending}
    >
      <Stack spacing={4}>
        <FormControl isRequired>
          <FormLabel>Teste gratuito até</FormLabel>
          <Input type="date" value={trialAte} onChange={(e) => setTrialAte(e.target.value)} />
          <FormHelperText>Para estender o teste, escolha uma data mais adiante.</FormHelperText>
        </FormControl>
        <FormControl>
          <FormLabel>Assinatura paga até</FormLabel>
          <Input
            type="date"
            value={assinaturaAte}
            onChange={(e) => setAssinaturaAte(e.target.value)}
          />
          <FormHelperText>
            Último dia coberto pelo pagamento. Deixe em branco se a conta não é assinante.
          </FormHelperText>
        </FormControl>
      </Stack>
    </ModalShell>
  );
}
